import { Types } from '@store/types';

const initialState = [];

const BrandReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_BRAND_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default BrandReducer;
